import axios from 'axios'
/* eslint-disable */
// const API_URL = 'http://api.ginfo.inovess.com.br'
const getApiUrl = () => {
  const currentHost = window.location.hostname

  if (currentHost === 'localhost') { return 'https://europe.api.ginfo.io/' }
  // if (currentHost === 'localhost') { return 'http://api.ginfo.inovess.com.br:8000' }
  // if (currentHost === 'localhost') { return 'http://api.ginfo.inovess.com.br' }

  // if (currentHost.includes('teste.terminaldaoficina.inovess.com.br')) { return 'http://sandbox.api.ginfo.inovess.com.br' }
  // if (currentHost.includes('terminaldaoficina.inovess.com.br')) { return 'https://api.ginfo.inovess.com.br' }
  if (currentHost.includes('teste.bi.ginfo.app.br')) { return 'https://api.ginfo.app.br/' }
  if (currentHost.includes('bi.ginfo.app.br')) { return 'https://api.ginfo.inovess.com.br/' }
  if (currentHost.includes('bi.ginfo.io')) { return 'https://api.ginfo.io/' }
  if (currentHost.includes('europe.bi.ginfo.io')) { return 'https://europe.api.ginfo.io/' }
}

// URL do serviço de chat com IA (pergunta/resposta sobre os dados do relatório).
// Hoje só existe o endpoint local de desenvolvimento; quando o serviço for
// publicado, adicione aqui a URL de cada ambiente (mesmo padrão do getApiUrl).
const getChatApiUrl = () => {
  const currentHost = window.location.hostname

  if (currentHost === 'localhost') { return 'http://localhost:8000' }

  // TODO: preencher com a URL do serviço de chat/IA em homologação/produção.
  return 'http://localhost:8000'
}

// TODO: substituir pelo workspaceId real do Power BI antes de usar em produção.
const WORKSPACE_ID_PADRAO = 'a06918c9-6598-4ba8-afe0-bdf04370773c'

// Enquanto o chat da tela inicial testa só o relatório de Ordem de Serviço,
// o reportId fica fixo aqui. Quando os demais relatórios entrarem, isso deixa
// de ser uma constante e passa a vir da escolha do usuário/contexto.
const REPORT_ID_PADRAO = '3f6c9790-3a9e-482f-8439-2392b5afbe29'
const REPORT_ID_ADERENCIA = '205a213c-0d27-439e-ba29-5b726bf8c69d'

// BIs disponíveis pra conversar no chat. Cada um aponta pro seu próprio
// reportId/workspaceId no Power BI (datasets sem RLS, liberados pro Execute
// Queries — ver conversa sobre a criação do dataset de Ordem de Serviço).
const BIS_DISPONIVEIS = [
  {
    id: 'ordem_servico',
    nome: 'Ordem de Serviço',
    icone: 'bi-clipboard-data',
    reportId: REPORT_ID_PADRAO,
    workspaceId: WORKSPACE_ID_PADRAO
  },
  {
    id: 'aderencia',
    nome: 'Aderência',
    icone: 'bi-speedometer2',
    reportId: REPORT_ID_ADERENCIA,
    workspaceId: WORKSPACE_ID_PADRAO // mesmo workspace do Ordem de Serviço
  }
]


const getLocalStorageToken = () => {
  if (!localStorage.getItem('filial')) {
    return null
  }

  const localStorageFilial = JSON.parse(localStorage.getItem('filial'))
  
  if (!localStorageFilial.token) {
    return null
  }

  return localStorageFilial.token
}

var unauthorizedCallback = null
const setUnauthorizedCallback = (callback) => {
  unauthorizedCallback = callback
}

const empresaLogin = () => {
  if(localStorage.empresa != undefined){
    var empresa = JSON.parse(localStorage.empresa)
  }

  return empresa
}

const empresaHash = () => {
  if(localStorage.empresa != undefined){
    try {
      var empresa = JSON.parse(localStorage.empresa)   
    
      return empresa.key

    } catch (error) {
      throw Error(error)
    }
  }

}

const client = axios.create({
  baseURL: `${getApiUrl()}`,
  headers: {
    Accept: 'application/json',
    ApiKey: `${empresaHash()}`,
    'Content-Type': 'application/json;charset=UTF-8',
    'Token': getLocalStorageToken()
  }
})


client.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response.status === 401) {
    if (unauthorizedCallback) {
      unauthorizedCallback()
    }
  }
  return Promise.reject(error)
})

const setToken = (client) => {
  client.defaults.headers.common.Token = getLocalStorageToken()

  return client
}

const chatClient = axios.create({
  baseURL: `${getApiUrl()}`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
    'Token': getLocalStorageToken()
  }
})

export default client

export { setToken, setUnauthorizedCallback, empresaLogin, chatClient, WORKSPACE_ID_PADRAO, REPORT_ID_PADRAO, BIS_DISPONIVEIS }
